import { render, staticRenderFns } from "./invoices-toolbar.vue?vue&type=template&id=4588a4c6&"
import script from "./invoices-toolbar.vue?vue&type=script&lang=js&"
export * from "./invoices-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports